import { useMutation, useQueryClient } from "@tanstack/react-query";
import { EditHealthReportFormValues } from "../schema/health-report.schema";
import { editHealthReport } from "../api/health-report.api";
import { healthKeys } from "./useHealthReports";
import { toast } from "react-toastify";

export const useEditHealtReport = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      reportId,
      values,
    }: {
      reportId: string;
      memberId: number;
      values: Partial<EditHealthReportFormValues>;
    }) => editHealthReport(reportId, values),

    onSuccess: (_, {memberId}) => {
      queryClient.invalidateQueries({ queryKey: healthKeys.list(memberId) });

      toast.success("Health Report Updated!");
    },

    onError: () => {
      toast.error("Failed to Update Report!");
    },
  });
};
